







import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import User from '@/models/Users/User'

export default Vue.extend({
  name: 'UserIndexColumn',
  components: {Avatar},
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number,
    toggleRowDetail: Function,
    row: Object as () => User,
  },
  computed: {
    recordNumber (): number {
      return this.scope.pagination.currentPage * this.scope.pagination.pageSize - this.scope.pagination.pageSize + this.rowIndex + 1
    }
  }
})
